export class TeacherAndSpecialistTestResultsVerbiagesChanged {
}
